import { Injectable } from '@angular/core'
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar'
import { SnackbarComponent } from '../components/revolution/snackbar/snackbar.component'

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  snackBarRef: MatSnackBarRef<SnackbarComponent> | undefined

  constructor (private readonly snackBar: MatSnackBar) {}

  showSnackbar (
    translationKey: string | string[],
    text: string,
    duration?: number
  ): void {
    this.closeSnackbar()

    const data: Record<string, unknown> = {
      text,
      action: true
    }

    if (Array.isArray(translationKey)) {
      data.translationKeyArray = translationKey
    } else {
      data.translationKey = translationKey
    }

    this.snackBarRef = this.snackBar.openFromComponent(SnackbarComponent, {
      panelClass: 'ef-snackbar',
      data,
      duration: (duration >= 0 ? duration : 5) * 1000
    })

    this.snackBarRef.afterDismissed().subscribe(() => {
      this.snackBarRef = undefined
    })
  }

  closeSnackbar (): void {
    this.snackBarRef?.dismiss()
  }
}
